import { Component } from '@angular/core';

@Component({
  selector: 'allas-beneficios-del-servicio',
  imports: [],
  template: `
    <section class="flex flex-col gap-2 mt-12">
      <h1
        class="text-2xl xl:text-4xl font-bold fs-condensed text-center text-appBlack"
      >
        BENEFICIOS DE NUESTRO SERVICIO
      </h1>
      <main
        class="grid grid-cols-1 xl:grid-cols-2 gap-8 xl:gap-28 max-w-screen-xl mx-auto mt-12"
      >
        @for (beneficio of beneficios; track beneficio.title) {
        <article class="grid grid-cols-12 gap-6">
          <span class="col-span-3 flex items-center justify-center">
            <img
              [src]="beneficio.icon"
              [alt]="beneficio.title"
              class="h-12 xl:h-20 w-auto"
            />
          </span>
          <span class="flex flex-col col-span-9">
            <h4
              class="text-base xl:text-xl font-black fs-condensed text-appBlack"
            >
              {{ beneficio.title }}
            </h4>
            <p
              class="text-sm xl:text-base font-light"
              [innerHTML]="beneficio.description"
            ></p>
          </span>
        </article>
        }
      </main>
    </section>
  `,
})
export class BeneficiosDelServicio {
  beneficios = [
    {
      title: 'TÉCNICOS EXPERTOS',
      icon: '/allas-icons/tools.svg',
      description: `Personal capacitado con años de <br /> experiencia en filtros automótrices.`,
    },
    {
      title: 'SERVICIO RÁPIDO',
      icon: '/allas-icons/clock-fast.svg',
      description: `Cambio de filtros en tiempo récord <br /> para que no pierdas tiempo.`,
    },
    {
      title: 'GARANTÍA TOTAL',
      icon: '/allas-icons/check-guard.svg',
      description: `Respaldamos nuestro trabajo con <br /> garantía completa en servicio y <br /> repuestos.`,
    },
    {
      title: 'FILTROS ORIGINALES',
      icon: '/allas-icons/filters.svg',
      description: `Solo utilizamos filtros originales y <br /> de marcas reconocidas.`,
    },
  ];
}
